import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextField, Grid, Box } from '@mui/material'

import { BrandsFitersType } from '@/state/brands/models'

type Props = {
  filters: BrandsFitersType
  handleChangeFilter: (filters: BrandsFitersType) => void
}

export const BrandsFilters = ({ filters, handleChangeFilter }: Props) => {
  const { t } = useTranslation()

  return (
    <Box borderRadius={10} mb={3}>
      <Grid container spacing={1} alignItems="flex-end">
        <Grid item xs={12} md={4}>
          <TextField
            autoComplete="off"
            fullWidth
            name="name"
            margin="dense"
            variant="outlined"
            label={t('labels.name')}
            value={filters?.name || ''}
            onChange={(e: React.ChangeEvent<{ value: string }>) => {
              handleChangeFilter({ ...filters, name: e.target.value })
            }}
            InputProps={{
              inputProps: {
                maxLength: 100,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            autoComplete="off"
            fullWidth
            name="siteId"
            margin="dense"
            variant="outlined"
            label={t('labels.siteId')}
            value={filters?.siteId || ''}
            onChange={(e: React.ChangeEvent<{ value: string }>) => {
              handleChangeFilter({ ...filters, siteId: e.target.value })
            }}
            InputProps={{
              inputProps: {
                maxLength: 100,
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  )
}
